import React from 'react';

function renderBackground(value) {
  if (value <= 0.1) {
    return null;
  } else {
    const path =
      value <= 0.4
        ? 'M0,3.5 L4,3.5 L4,8 L2,9.5 L3,6 L0,3.5'
        : value <= 0.6
        ? 'M0,3.5 L4,3.5 L5.5,0 L5.5,7.5 L2,9.5 L3,6 L0,3.5'
        : value <= 0.95
        ? 'M0,3.5 L4,3.5 L5.5,0 L7,3.5 L7,8 L6.5,7.5 L2,9.5 L3,6 L0,3.5'
        : 'M0,3.5 L4,3.5 L5.5,0 L7,3.5 L10.5,3.5 L8,6 L9,9.5 L5.5,7.5 L2,9.5 L3,6 L0,3.5';
    return (
      <path
        strokeWidth="0"
        strokeLinejoin="round"
        strokeLinecap="round"
        d={path}
      />
    );
  }
}

function StarIconPartial({ width = 11, height = 10, value = 1, ...rest }) {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 11 10">
      <g>
        <path
          fill="transparent"
          strokeWidth="1"
          strokeLinejoin="round"
          strokeLinecap="round"
          d="M0,3.5 L4,3.5 L5.5,0 L7,3.5 L10.5,3.5 L8,6 L9,9.5 L5.5,7.5 L2,9.5 L3,6 L0,3.5"
        />
        {renderBackground(value)}
      </g>
    </svg>
  );
}

export default React.memo(StarIconPartial);
